import { render } from "./OfflineLessons.vue?vue&type=template&id=2ec70c27&scoped=true"
import script from "./OfflineLessons.vue?vue&type=script&lang=js"
export * from "./OfflineLessons.vue?vue&type=script&lang=js"

import "./OfflineLessons.vue?vue&type=style&index=0&id=2ec70c27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec70c27"]])

export default __exports__